module.exports = __webpack_public_path__ + "static/media/tehuantepec.cf0ddfdc.jpeg";